import React, { useCallback, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { DashboardContext } from './dashboard.context';

import MonitoringActions from '../../components/monitoringActions/monitoringActions';
import MonitoringContent from '../../components/monitoringContent/monitoringContent';

import { Title } from '../../components';

import { config } from '../../api/config';
import { actions } from '../../state';
import { isBusinessAdmin } from '../../utils';

import styles from './dashboard.module.scss';

const Dashboard = ({ dispatch, isImpersonating, role }) => {
  const {
    filteredBody,
    dateFromLtFilter,
    setDateFromLtFilter,
    dateToGtFilter,
    setDateToGtFilter,
    locationId,
    setLocationId,
    serviceId,
    setServiceId,
    handleSubmit,
    clearFilters,
  } = useContext(DashboardContext);

  const clearMonitoring = useCallback(() => {
    dispatch(actions.monitoring.clearMonitoringAction());
  }, [dispatch]);

  const fetchMonitoringData = useCallback(data => {
    dispatch(actions.monitoring.getMonitoringAction(data));
  }, []);

  useEffect(() => () => clearMonitoring(), [clearMonitoring]);

  useEffect(() => {
    fetchMonitoringData(filteredBody);
  }, [fetchMonitoringData, filteredBody]);

  if (isImpersonating || isBusinessAdmin(role)) {
    return <Redirect to={config.APP_PATHS.baEmployees} />;
  }

  return (
    <section className={styles.pageSection}>
      <div className={styles.pageTitle}>
        <Title>{config.PAGES.dashboard}</Title>
        <MonitoringActions
          filteredBody={filteredBody}
          locationId={locationId}
          setLocationId={setLocationId}
          dateFromLtFilter={dateFromLtFilter}
          setDateFromLtFilter={setDateFromLtFilter}
          dateToGtFilter={dateToGtFilter}
          setDateToGtFilter={setDateToGtFilter}
          handleSubmit={handleSubmit}
          clearFilters={clearFilters}
        />
      </div>
      <MonitoringContent serviceId={serviceId} setServiceId={setServiceId} />
    </section>
  );
};

Dashboard.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isImpersonating: PropTypes.bool.isRequired,
  role: PropTypes.number,
};

const mapStateToProps = state => ({
  isImpersonating: state.auth.isImpersonating,
  role: state.auth.user?.role,
});

export default connect(mapStateToProps)(Dashboard);
